import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import AppLayout from "./Layout/AppLayout";
import LogoutPage from "./Pages/LogoutPage";
import { Spinner } from "react-bootstrap";

function App() {
  const auth = useAuth();

  useEffect(() => {
    if (
      !auth.isLoading &&
      !auth.isAuthenticated &&
      location.pathname !== "/logout"
    ) {
      auth.signinRedirect(); 
    }
  }, [auth.isLoading, auth.isAuthenticated, location.pathname, auth]);

  if (auth.isLoading) {
    return (
      <div className="loading-container">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="loading-container">
        Encountering error... {auth.error.message}
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/logout" element={<LogoutPage />} />

        <Route
          path="/*"
          element={auth.isAuthenticated ? <AppLayout /> : null}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
